// body の data 属性を見て、画面ごとの初期化関数を呼ぶディスパッチャ (#2935)。
//
// 以前は各ビューの末尾にインラインの <script> を置いて window.DD.X.Y() を直接呼んでいた。
// CSP の script-src に 'unsafe-inline' が必要になるうえ、インラインはパース中に走るため
// 外部スクリプトを defer にできなかった。
//
// Ruby 側の宣言は app/helpers/view_script_helper.rb を参照。
//
//   - data-layout-script      レイアウト共通の初期化 (引数なし)
//   - data-view-script        画面ごとの初期化
//   - data-view-script-args   その引数 (JSON 配列)

function callScript(registry, name, rawArgs) {
  if (!name) return;

  const fn = registry[name];
  if (typeof fn !== 'function') {
    // 名前の書き間違いに気付けるようにする。spec でも検出しているが、
    // 実行時にも黙って何も起きない状態にはしない
    console.warn(`[view-script] 登録されていない名前です: ${name}`);
    return;
  }

  let args = [];
  if (rawArgs) {
    try {
      args = JSON.parse(rawArgs);
    } catch (error) {
      console.warn(`[view-script] 引数を解釈できませんでした: ${name}`, error);
      return;
    }
  }

  fn(...args);
}

// @param registry {Object} 名前 -> 初期化関数
export default function runViewScripts(registry) {
  const run = () => {
    const body = document.body;
    if (!body) return;

    // レイアウト共通 -> 画面ごと の順に呼ぶ (サイドバーの活性化などが先に済む)
    callScript(registry, body.dataset.layoutScript);
    callScript(registry, body.dataset.viewScript, body.dataset.viewScriptArgs);
  };

  document.addEventListener('turbolinks:load', run);
}
